import { writable, get } from 'svelte/store';

import {
    FIRST_SCREEN_IMAGES_A,
    REMAINING_IMAGES_A,
    FIRST_SCREEN_IMAGES_B,
    REMAINING_IMAGES_B
} from '../constants/imgList';
import ImagePreloader from '../utils/imagePreloader';

// 存储已加载完成的图片URL
export const loadedImages = writable<Set<string>>(new Set());
export const loadingProgress = writable(0);
export const isFirstScreenLoaded = writable(false);
export const isAllLoaded = writable(false);
interface ImageGroup<K> {
    FIRST_SCREEN_IMAGES: K;
    REMAINING_IMAGES: K;
}
interface ImageType<T> {
    [key: string]: ImageGroup<T[]>;
}
export function startPreload(type: string) {
    const targetObj: ImageType<string> = {
        A: {
            FIRST_SCREEN_IMAGES: FIRST_SCREEN_IMAGES_A,
            REMAINING_IMAGES: REMAINING_IMAGES_A
        },
        B: {
            FIRST_SCREEN_IMAGES: FIRST_SCREEN_IMAGES_B,
            REMAINING_IMAGES: REMAINING_IMAGES_B
        }
    };
    const { FIRST_SCREEN_IMAGES, REMAINING_IMAGES } = targetObj[type] || {};
    const preloader = new ImagePreloader(FIRST_SCREEN_IMAGES, REMAINING_IMAGES);

    // 在 Vite 中，导入的图片已经是处理过的 URL，可以直接使用
    // 如果仍需要预加载以确保图片加载完成，保留现有逻辑

    preloader.preload({
        onImageLoad: (src) => {
            // 单个图片加载完成时更新store
            loadedImages.update((images) => {
                images.add(src);

                return images;
            });
        },
        onProgress: (progress) => {
            loadingProgress.set(progress);
        },
        onFirstScreenComplete: () => {
            isFirstScreenLoaded.set(true);
        },
        onAllComplete: () => {
            isAllLoaded.set(true);
        },
        onError: (error) => {
            console.error('Image preload error:', error);
            // 即使加载失败也继续进行，避免阻塞
            loadingProgress.update((progress) => Math.min(progress + 1, 100));
        },
        shouldPreload: (src) => {
            let shouldLoad = true;

            loadedImages.update((images) => {
                if (images.has(src)) {
                    shouldLoad = false;
                }

                return images;
            });

            return shouldLoad;
        }
    });
}
